<template>
	<v-hover v-slot="{ hover }">
		<v-btn
			@click="action"
			elevation="0"
			small
			:loading="isLoading"
			:class="[highlighted, {
					'grey--text' : (!hover && !highlighted) || isLoading,
					'text--darken-2 white' : hover && !highlighted
				},
				'font-12 transparent']"
			:ripple="false">
			<v-icon class="font-12 mr-2">{{ icon }}</v-icon>
			{{ text }}
		</v-btn>
	</v-hover>
</template>

<script>
export default {
	name: "PostCommentButton",
	props: {
		text: {
			type: String,
			required: true
		},
		sending: {
			type: String,
			default: null
		},
		type: {
			type: String,
			default: null
		},
		icon: {
			type: String,
			required: true
		},
		action: {
			type: Function,
			required: true
		},
		highlighted: {
			type: [Boolean, String],
		},
		loading: {
			type: Boolean
		},
	},
	computed: {
		isLoading: function () {
			return this.loading || (this.sending && this.type && (this.sending === this.type))
		}
	}
}
</script>

<style scoped>

</style>
